import React from "react";
import { Route } from "react-router";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header";
import HomeScreen from "./components/HomeScreen";
import PrintAsn from "./components/PrintAsn";
import PrintAsnPbarcode from "./components/PrintAsnPbarcode";
import PrintReturns from "./components/PrintReturns";
import PrintIpksReturns from "./components/PrintIpksReturns";
import PrintRTV from "./components/PrintRTV";
import PrintDSWmsBarcode from "./components/PrintDSWmsBarcode";
import PrintPartner from "./components/PrintPartner";
import { initializeSentryBrowser } from "./utils/sentryHelper";
import { initQZTray } from "./utils/qzHelper";

export default class App extends React.Component {
  componentDidMount() {
    initializeSentryBrowser();
    initQZTray();
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <div id="siteWrapper">
            <Header />
            <div id="siteContent" className="siteWidthContainer">
              <Route exact={true} path={`/`} component={HomeScreen} />
              <Route exact={true} path={`/asn/:idAsn`} component={PrintAsn} />
              <Route
                exact={true}
                path={`/large-asn/:idAsn`}
                component={PrintAsn}
              />
              <Route
                exact={true}
                path={`/pbarcode/:idPartner/:idAsn`}
                component={PrintAsnPbarcode}
              />
              <Route
                exact={true}
                path={`/asn-discrepancy/:idPartner/:idAsn`}
                component={PrintAsnPbarcode}
              />
              <Route
                exact={true}
                path={`/pbarcode-xdock/:idPartner/:idAsn`}
                component={PrintAsnPbarcode}
              />
              <Route
                exact={true}
                path={`/partner/:idPartner`}
                component={PrintPartner}
              />
              <Route
                exact={true}
                path={`/returns/:awb`}
                component={PrintReturns}
              />
              <Route
                exact={true}
                path={`/ipks-returns/:awb`}
                component={PrintIpksReturns}
              />
              <Route exact={true} path={`/rtv/:rtv_nr`} component={PrintRTV} />
              <Route
                exact={true}
                path={`/darkstore-wms-barcode/:awb`}
                component={PrintDSWmsBarcode}
              />
            </div>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js